export const Languages = ['en'];

export const TIME_OUT = 300 * 1000;

export const DEFAULT_PAGE = 1;
export const PREPARATION_THRESHOLD = 3;
export const ROWS_PER_PAGE = 10;
export const ITEMS_PER_BOARD_PAGE = 6;
export const STATUS_TABS: Array<string> = ['all', 'progress', 'hold', 'completed'];

export const DIALOG_MODE_CREATE = 'create';
export const DIALOG_MODE_EDIT = 'edit';
export const DIALOG_MODE_VIEW = 'view';

export const VALUE_TRUE = 'true';
export const VALUE_FALSE = 'false';

export const MAP_DEFAULT_LAT = 41.850033;
export const MAP_DEFAULT_LONG = -87.6500523;
export const FIXED_VALUE = 4;
export const SAVE_TYPES = {
  NO: 'no',
  NEW: 'new',
  EXIST: 'exist',
};

export const FILE_MIME_TYPE_FORMAT = {
  IMAGE: {
    INDEX: 'image',
    PNG: 'image/png',
    JPG: 'image/jpg',
    JPEG: 'image/jpeg',
    GIF: 'image/gif',
  },
  VIDEO: {
    INDEX: 'video',
    MP4: 'video/mp4',
  },
  DOCUMENT: {
    PDF: 'application/pdf',
    XLSX: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    XLS: 'application/vnd.ms-excel',
    DOCX: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    DOC: 'application/msword',
    TXT: 'text/plain',
    PPTX: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    PPT: 'application/vnd.ms-powerpoint',
  },
};

export const QUEUE_STATUS_PROCESS = 'PROCESS';
export const QUEUE_STATUS_SUCCESS = 'SUCCESS';
export const QUEUE_STATUS_FAILED = 'FAILED';
